<template>
  <div class="_order-card-list">
    <template v-for="order in orders">
      <template>
        <desktop-order-card
          :key="`desktop/${order._id}`"
          v-bind="order"
          :order-id="order._id"
          :is-new-line-official-account="isNewLineOfficialAccount(order.type)"
          :is-transfer-line-official-account="isTransferLineOfficialAccount(order.type)"
          :new-line-official-account-type-text="newLineOfficialAccountTypeText(order.type)"
          :transfer-agency-payment-type-text="transferAgencyPaymentTypeText(
            order.transferAgencyPaymentType
          )"
          :is-juristic-customer="isJuristicCustomer(order)"
          :withholding-tax-status="order.withholdingTaxStatus"
          :peak-receipt-document-url="order.peakReceiptDocumentUrl"
          class="d-none d-md-block mt-4"
          @delete="deleteOrder"
          @view-tax-document="viewTaxDocument">
        </desktop-order-card>
        <mobile-order-card
          :key="`mobile/${order._id}`"
          v-bind="order"
          :order-id="order._id"
          :is-new-line-official-account="isNewLineOfficialAccount(order.type)"
          :is-transfer-line-official-account="isTransferLineOfficialAccount(order.type)"
          :new-line-official-account-type-text="newLineOfficialAccountTypeText(order.type)"
          :transfer-agency-payment-type-text="transferAgencyPaymentTypeText(
            order.transferAgencyPaymentType
          )"
          :is-juristic-customer="isJuristicCustomer(order)"
          :withholding-tax-status="order.withholdingTaxStatus"
          :peak-receipt-document-url="order.peakReceiptDocumentUrl"
          class="d-md-none mt-4"
          @delete="deleteOrder"
          @view-tax-document="viewTaxDocument">
        </mobile-order-card>
      </template>
    </template>
  </div>
</template>

<script>
import { OrderService } from '@/providers'
import { isJuristicCustomer } from '@/utils/order.util'
import { mapActions } from 'vuex'

const DesktopOrderCard = () => import('./DesktopOrderCard')
const MobileOrderCard = () => import('./MobileOrderCard')

export default {
  name: 'OrderCardListIndex',
  components: {
    DesktopOrderCard,
    MobileOrderCard
  },
  props: {
    orders: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    ...mapActions({
      deleteOrderById: 'Order/deleteOrderById'
    }),
    async deleteOrder(orderId, code) {
      const { value: confirm } = await this.$swal({
        title: 'ลบใบเสนอราคา',
        html: `คุณต้องการลบใบเสนอราคา <b>${code}</b><br>ใช่หรือไม่`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก'
      })

      if (confirm) {
        await this.deleteOrderById(orderId)
        this.$emit('deleted', orderId)
      }
    },
    isNewLineOfficialAccount (orderType) {
      return orderType === 'newLineOfficialAccount'
    },
    isTransferLineOfficialAccount (orderType) {
      return orderType === 'transferLineOfficialAccount'
    },
    newLineOfficialAccountTypeText (orderType) {
      if (this.isTransferLineOfficialAccount(orderType)) {
        return 'ย้ายมาจาก Agency อื่น'
      }

      if (this.isNewLineOfficialAccount(orderType)) {
        return 'เปิด LINE Official Account ใหม่'
      }

      return ''
    },
    transferAgencyPaymentTypeText (transferAgencyPaymentType) {
      return transferAgencyPaymentType === 'lineThailand'
        ? 'ชำระผ่าน LINE Thailand'
        : 'ชำระผ่าน Agency เจ้าอื่น'
    },
    async viewTaxDocument(orderId, orderCode) {
      try {
        this.$wait.start('downloading-receipt')

        // Use proxy endpoint that handles authentication and sets proper filename
        const response = await OrderService.downloadReceipt(orderId)

        // Get filename from Content-Disposition header, fallback to generated name
        let filename = `Taxinvoice-${orderCode}-${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.pdf`
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/)
          if (filenameMatch) {
            [, filename] = filenameMatch
          }
        }

        // Create blob URL and download
        const blob = new Blob([response.data])
        const blobUrl = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = blobUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // Clean up blob URL
        URL.revokeObjectURL(blobUrl)
      } catch (error) {
        if (error.response && error.response.status === 410) {
          // Show expiration popup
          this.$swal({
            title: 'ไม่สามารถดาวน์โหลดได้',
            html: '<div style="font-size: 1rem;">ไฟล์เอกสารนี้หมดอายุเเล้ว หากต้องการเอกสารติดต่อได้ที่ <span style="text-decoration: underline;">lineagency@sellsuki.com</span> หรือ LINE @linebysellsuki</div>',
            icon: 'warning',
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#4CAF50'
          })
        } else {
          this.$swal({
            title: 'ไม่สามารถดาวน์โหลดได้',
            html: 'ไฟล์เอกสารนี้หมดอายุเเล้ว หากต้องการเอกสารติดต่อได้ที่<br> <a href="mailto:lineagency@sellsuki.com" style="color: #545454;">lineagency@sellsuki.com</a> หรือ LINE @linebysellsuki',
            icon: 'warning'
          })
        }
      } finally {
        this.$wait.end('downloading-receipt')
      }
    },
    isJuristicCustomer
  }
}
</script>
